import { useDispatch, useSelector } from 'react-redux';
import * as React from 'react';

import { FavoriteButton } from '../../components/FavoriteButton';
import { selectRecommendationById } from '../../selectors/recommendations';
import { deleteFromFavorite } from '../../thunk/recommendations/deleteFromFavorite';
import { addToFavorite } from '../../thunk/recommendations/addToFavorite';

interface IRecommendationFavoriteButtonContainerProps {
  id: number;
}

export const RecommendationFavoriteButtonContainer: React.FC<IRecommendationFavoriteButtonContainerProps> = ({
  id,
}) => {
  const dispatch = useDispatch();
  const recommendation = useSelector(selectRecommendationById(id));

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      event.preventDefault();

      if (!recommendation) {
        return;
      }

      const action = recommendation.isFavorite ? deleteFromFavorite : addToFavorite;

      dispatch(action(recommendation));
    },
    [dispatch, recommendation],
  );

  if (!recommendation) {
    return null;
  }

  return <FavoriteButton onClick={handleClick} isActive={recommendation.isFavorite} />;
};
